module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-2-min.f6f75abd.jpg";